import { render, staticRenderFns } from "./LabelsDropdown.vue?vue&type=template&id=144a8882&"
import script from "./LabelsDropdown.vue?vue&type=script&lang=ts&"
export * from "./LabelsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports